const numeral: any = require('numeral');

export class StringHelper {
	static padLeft(text: string, padChar: string, size: number): string {
		return (String(padChar).repeat(size) + text).substr((size * -1), size);
	}

	static formatCurrency(amount: number): string {
		return numeral(amount).format('($0,0.00)');
	}
}
